import React from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

const buttonStyles = {
  zIndex: 2,
  buttonOffset: 15,
  borderRadius: '50%',
  textAlign: 'center',
  border: '1.5px solid #D4A976',
  backgroundColor: '#202020',
  color: '#D4A976',
  top: 'calc(50% - 25px)',
  width: '50px',
  height: '50px',
  lineHeight: '50px',
  cursor: 'pointer'
};
export const CustomLeftArrow = ({ onClick, left, position }) => {
  return (
    <button style={{ ...buttonStyles, left: left || 0, position: position || 'absolute' }} onClick={() => onClick()}>
      <KeyboardArrowLeftIcon
        fontSize={'large'}
        style={{ marginTop: '-0.25rem', marginRight: 2 }}
      />
    </button>
  );
};
export const CustomRightArrow = ({ onClick, right, position }) => {
  return (
    <button style={{ ...buttonStyles, right: right || 0, position: position || 'absolute' }} onClick={() => onClick()}>
      <KeyboardArrowRightIcon
        fontSize={'large'}
        style={{ marginTop: '-0.25rem', marginLeft: 2 }}
      />
    </button>
  );
};
